import { getNumberOrZero } from '@/common/utils';
import { useCurrentUser } from '../use-current-user';
import { useGetPrizeEntriesQuery } from './graphql.generated';

export const usePrizeEntryCount = () => {
	const { currentUser, loading: userLoading } = useCurrentUser();
	const { data, loading, refetch } = useGetPrizeEntriesQuery({
		variables: {
			userId: currentUser?.id ?? '',
			month: new Date().getMonth() + 1,
			year: new Date().getFullYear(),
		},
		skip: !currentUser?.id,
	});

	return {
		monthlyCount: getNumberOrZero(data?.monthlyPrizeEntryCounts?.[0]?.count),
		yearlyCount: getNumberOrZero(data?.yearlyPrizeEntryCounts?.[0]?.count),
		loading: userLoading || loading,
		refetch,
	};
};
